(() => {
  const dialog = document.querySelector('[data-look-gallery-dialog]');
  if (!dialog || dialog.dataset.purchaseOptionsReady) return;
  dialog.dataset.purchaseOptionsReady = 'true';
  const stage = dialog.querySelector('[data-gallery-stage]');
  let card = null;
  const chooser = () => dialog.querySelector('[data-look-purchase-option]');
  const choices = select => [...select.options];
  const safeUrl = value => {
    try {
      const url = new URL(value);
      return url.protocol === 'https:' && ['www.amazon.com','amazon.com','link.amazon','amzn.to'].includes(url.hostname) ? url.href : null;
    } catch { return null; }
  };
  function apply(select, changeImage) {
    const option = select.selectedOptions[0];
    const url = safeUrl(option?.value);
    if (!option || !url || !card) return;
    card.dataset.selectedPurchaseOption = option.value;
    dialog.querySelectorAll('[data-gallery-actions] a[data-gallery-purchase],[data-gallery-mobile-actions] a[data-gallery-purchase]').forEach(link => { if (link.tagName === 'A') link.href = url; });
    card.querySelectorAll('a[data-gallery-direct]').forEach(link => { link.href = url; });
    const source = card.querySelector('[data-gallery-purchase-source]')?.content.querySelector('a[data-gallery-purchase]');
    if (source) source.href = url;
    const status = dialog.querySelector('[data-look-option-status]');
    if (status) status.textContent = option.textContent + ' selected. The purchase button opens this color and size on Amazon.';
    if (changeImage) {
      const thumb = [...dialog.querySelectorAll('[data-gallery-thumbs] [data-gallery-src]')].find(button => button.dataset.gallerySrc.includes(option.dataset.optionImage));
      if (thumb && thumb.getAttribute('aria-pressed') !== 'true') thumb.click();
    }
  }
  function initialize(event) {
    card = event.detail?.card || null;
    const select = chooser();
    if (!select || !card) return;
    const saved = choices(select).find(option => option.value === card.dataset.selectedPurchaseOption);
    if (saved) select.value = saved.value;
    apply(select, true);
  }
  dialog.addEventListener('dst:gallery-opened', initialize);
  dialog.addEventListener('change', event => {
    if (event.target.matches('[data-look-purchase-option]')) apply(event.target, true);
  });
  if (stage) new MutationObserver(() => {
    const select = chooser();
    const src = stage.getAttribute('src') || '';
    if (!select || !card || !src) return;
    const current = select.selectedOptions[0];
    const color = ['black','brown','khaki'].find(value => src.includes('handbag-' + value + '-studio') || src.includes('handbag-ava-' + value));
    if (!color) return;
    const match = choices(select).find(option => option.dataset.optionColor.toLowerCase() === color && option.dataset.optionSize === current?.dataset.optionSize);
    if (match) { select.value = match.value; apply(select, false); }
  }).observe(stage, {attributes:true,attributeFilter:['src']});
})();
